import Pagination from "react-js-pagination";
import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";
import moment from "moment";

import routes from '../libs/routes';
import images from "../libs/images";
import * as API from "../libs/service";
import { useSelector } from "react-redux";

export default function PaginationCoupon(props) {
    const {
        coupon
    } = props

    const dataList = coupon || [];

    const [page, setPage] = useState(1);
    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };  
    const lang = useSelector(state => state.langReducer.lang);

    /* console.log('123123', coupon); */

    const itemsPerPage = 8;
    const indexOfLastItem = page * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const Items = dataList.slice(indexOfFirstItem, indexOfLastItem);

    return (
        <div className="PaginationContent">
            <div className="my_coupon_list_box page_coupon">
                <div className="list_title">
                    <p>{lang === 0 ? '발급일' : 'Date of Issue'}</p>
                    <p>{lang === 0 ? '쿠폰코드' : 'Coupon Code'}</p>
                    <p>{lang === 0 ? '할인율' : 'Discount Rate'}</p>
                    <p>{lang === 0 ? '유효기간' : 'Expiration Date'}</p>
                    <p>{lang === 0 ? '사용여부' : 'Usage Status'}</p>
                </div>

                {coupon ?
                    <>
                        {Items.map((x, i) => (
                            <div key={i} className={`my_coupon_info ${x?.coupon_status != 0 ? 'off' : ''}`}>
                                <p>{moment(x?.create_dt).format("YYYY-MM-DD")}</p>
                                <p className="code">{x?.couponCode}</p>
                                <p>{x?.discount}%</p>
                                <p>{moment(x?.validityDate).format("YYYY-MM-DD")}</p>
                                <p>{x?.statusTxt}</p>
                            </div>
                        ))}
                    </>
                    :
                    <p className="not_coupon">{lang === 0 ? '보유한 쿠폰이 없습니다.' : 'You have no coupons.'}</p>
                }                
            </div>

            <Pagination
                className="my-pagination"
                // 현재 보고있는 페이지
                activePage={page}
                // 한페이지에 출력할 아이템수
                itemsCountPerPage={8}
                // 총 아이템수
                totalItemsCount={dataList.length || 1}
                // 표시할 페이지수
                pageRangeDisplayed={10}
                // 함수
                onChange={handlePageChange}
                nextPageText={<img src={require("../assets/icon/page_right.svg").default}/>}
                prevPageText={<img src={require("../assets/icon/page_left.svg").default}/>}
                firstPageText={<img src={require("../assets/icon/page_left_set.svg").default}/>}
                lastPageText={<img src={require("../assets/icon/page_right_set.svg").default}/>}
            ></Pagination>
        </div>
    )
}